import { getters } from './getters';
import * as actions from './actions';
import { state } from './models';
import { mutations } from './mutations';

export const groupIndexingRuleModule = {
  state,
  getters,
  actions,
  mutations,
};
